module.exports = __webpack_public_path__ + "static/MT174.f06c1137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MT174.png
// module id = 55
// module chunks = 21434532657768 117696030705815 145011745361637